import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useStyles } from './styles';

import CountryCodeList from './countryCodeList';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import useCountryCodeUIState from './useCountryCodeUIState';
function MobileInput (props) {

    const {
        widget,
        widgetTheme,
        className,
        label = 'Phone number',
        onChange = () => {},
        value = {},
        helperText = 'Phone number',
        error = false,
        placeHolderText = 'Phone number',
    } = props;
 
    const {
        openList,
        listAnchor,
        country,
        countryCode,
        openCountryCodeList,
        closeCountryCodeList,
        selectCountryCode,
        codeIndex,
        onPhoneKeyDown,
        phoneNumber,
        setPhoneNumber,
    } = useCountryCodeUIState({
        value,
    });

    const classes = useStyles({
        widget,
        widgetTheme,
        error,
        helperText,
    });
    
    function getLabel () {
        return label;
    }
   
    return (
        <React.Fragment>
            <Grid
                id='phone-input'
                className={classNames(['ecal-reg-field-mobile', classes.container, className])}
            >
                <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                    { getLabel() }
                </span>

                <Grid className={classNames(['ecal-input', classes.fieldBase])}>
                    
                    <Button className={classes.button}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openCountryCodeList({ anchor: e.target });
                        }}
                        data-ecal-id='flagPicker'
                    >
                        <span className={classNames([
                            classes.flags,
                            classes[`flag_${country}`],
                        ])}>

                        </span>
                        <span className={classes.listItemCode}>
                            +{countryCode}
                        </span>
                        <DownIcon
                            size="small"
                            className={classes.downIcon}
                        />
                    </Button>
                    <input
                        name="mobile"
                        onKeyDown={onPhoneKeyDown}
                        onChange={(e) => {
                            setPhoneNumber(e.target.value)
                            if (typeof onChange === 'function') {
                                onChange({
                                    countryCode,
                                    phoneNumber: e.target.value,
                                    value: countryCode + e.target.value,
                                    codeIndex,
                                    country,
                                });
                            }
                        }}

                        onBlur={(e) => {
                            if (typeof onChange === 'function') {
                                onChange({
                                    countryCode,
                                    phoneNumber: e.target.value,
                                    value: countryCode + e.target.value,
                                    codeIndex,
                                    country,
                                });
                            }
                        }}

                        value={phoneNumber}
                        className={classes.textInput}
                        placeholder={placeHolderText}
                        autoComplete="off"
                    />
                </Grid>

                <span className={classes.helperText}>
                    {helperText}
                </span>
            </Grid>

            <CountryCodeList
                open={openList}
                anchorEl={listAnchor}
                onCloseList={() => closeCountryCodeList()}
                onItemClick={(p) => {
                    selectCountryCode(p);
                    onChange({
                        codeIndex: p.index,
                        countryCode: p.data.code,
                        country: p.data.iso2,
                        phoneNumber,
                        value:  p.data.code + phoneNumber,
                    });
                    closeCountryCodeList();
                }}
                selectedCodeIndex={codeIndex}
                value={value}
            />

        </React.Fragment>
    );
}

MobileInput.propTypes = {
    label: PropTypes.string,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    error: PropTypes.bool,
    placeHolderText: PropTypes.string,
};

export default MobileInput;
